import { flatten, sortBy } from 'lodash'
import repository from '@/repositories/Repository'

const resource = '/items'
// コード検索を行う際一回で送信するコード数
// GETで商品コードを送るため、長すぎになることを防ぐため最大値を用意
const ITEMS_SEND_CHUNK_SIZE = 100

// カテゴリツリーから全て選択して検索すると長すぎになるため分割
const CATEGORIES_SEND_CHUNK_SIZE = 100

const downloadResource = '/api/item'

/**
 * 商品マスタ
 */
export default {
  /**
   * 指定キーワードで商品検索を行う
   *
   * @param {String} company 企業コード
   * @param {Array<String>} categories 最下層の分類コード
   * @param {String} keyword 検索ワード
   */
  getByKeyword(company, categories, keyword) {
    if (categories.length) {
      const categoriesCopy = Array.from(categories)
      const chunks = []
      while (categoriesCopy.length > 0) {
        chunks.push(categoriesCopy.splice(0, CATEGORIES_SEND_CHUNK_SIZE))
      }

      return Promise.all(
        chunks.map(chunk => {
          return repository.bizoo
            .get(
              `${resource}/${company}?itemCategories=${chunk.join(
                ',',
              )}&keyword=${keyword}`,
            )
            .then(r => r.data)
        }),
      ).then(results => sortBy(flatten(results), result => result.code))
    } else {
      return repository.bizoo
        .get(`${resource}/${company}?keyword=${keyword}`)
        .then(r => r.data)
    }
  },
  /**
   * 商品コードから商品検索を行う
   *
   * @param {String} company 企業コード
   * @param {Array<String>} codes 商品コード
   */
  getByCode(company, codes) {
    const codesCopy = Array.from(codes)
    const chunks = []
    while (codesCopy.length > 0) {
      chunks.push(codesCopy.splice(0, ITEMS_SEND_CHUNK_SIZE))
    }

    return Promise.all(
      chunks.map(chunk => {
        return repository.bizoo
          .get(`${resource}/${company}?codes=${chunk.join(',')}`)
          .then(r => r.data)
      }),
    ).then(results => flatten(results))
  },
  getByMaker(maker) {
    const [company] = maker.split(',')
    return repository.bizoo
      .get(`${resource}/${company}?maker=${maker}`)
      .then(r => r.data)
  },
  downloadCsvByItemGroupId(itemGroupId) {
    return repository.giggle
      .get(`${downloadResource}/download/${itemGroupId}`)
      .then(r => r.data)
  },
}
